import React from 'react';
import PropTypes from 'prop-types';
import ListingTypeNotice from 'common/components/listingTypeNotice';
import { listingTypeNoticeHint, listingTypeNoticeContent } from 'common/constants/reconciliation';

export default class ReconciliationHeader extends React.Component {
  render() {
    const { t } = this.props;
    return (
      <div className="reconciliation-list__header">
        <h3 className="reconciliation-list__title">{t('landlord.reconciliation_list.title')}</h3>
        <ListingTypeNotice
          t={t}
          button={listingTypeNoticeHint}
          content={listingTypeNoticeContent}
        />
      </div>
    );
  }
}

ReconciliationHeader.propTypes = {
  t: PropTypes.func,
  readyForApprovalCount: PropTypes.number,
  pendingCount: PropTypes.number,
};

ReconciliationHeader.defaultProps = {
  t: () => {},
  readyForApprovalCount: 0,
  pendingCount: 0,
};
